export default __webpack_public_path__ + "static/media/default-user-profile.c0a7f0b4.svg";